import { createColumnHelper } from '@tanstack/react-table';
import { Avatar, ColumnFilterType, Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { GroupMember, UserStatus } from '@mews-commander/data-access';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { UserStatusTag } from '../../../userManagement/components/UserStatusTag';

const columnHelper = createColumnHelper<GroupMember>();

const UserTableAvatar = ({ user }: { user: GroupMember }) => {
    const getAvatarSrc = useGetAvatarSrc();
    const avatarImage = getAvatarSrc(user.imageId);

    return (
        <Stack spacing="100" itemAlignment="center">
            <Avatar src={avatarImage} title={user.fullName || ''} size="small" />

            <span>{user.fullName}</span>
        </Stack>
    );
};

export const useColumns = () => [
    columnHelper.accessor('fullName', {
        id: 'fullName',
        header: () => <LocalizedText textKey={TextKey.Name} />,
        cell: (props) => <UserTableAvatar user={props.row.original} />,
        enableSorting: true,
    }),
    columnHelper.accessor('email', {
        id: 'email',
        header: () => <LocalizedText textKey={TextKey.Email} />,
        cell: (props) => props.getValue(),
    }),
    columnHelper.accessor('status', {
        id: 'status',
        header: () => <LocalizedText textKey={TextKey.Status} />,
        cell: (props) => {
            const status = props.getValue();
            return status ? <UserStatusTag status={status} /> : null;
        },
        enableColumnFilter: true,
        meta: {
            filtersType: ColumnFilterType.MultiSelect,
            getMultiSelectOptions: () => [
                {
                    value: UserStatus.Active,
                    label: <LocalizedText textKey={TextKey.Active} />,
                },
                {
                    value: UserStatus.Pending,
                    label: <LocalizedText textKey={TextKey.Pending} />,
                },
                {
                    value: UserStatus.Disabled,
                    label: <LocalizedText textKey={TextKey.Deactivated} />,
                },
            ],
        },
    }),
];
